// extracted by mini-css-extract-plugin
export default {"entry-form":"Et1stBy6jNd87rIQv_0r"};